module.exports = __webpack_public_path__ + "static/media/purse.d5a6c167.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/purse.svg
 ** module id = 133
 ** module chunks = 0
 **/